export const COLORS = {
  bg: "bg-[#06080D]",
  gold: "text-[#C8A96E]",
  goldBg: "bg-[#C8A96E]",
  goldBorder: "border-[#C8A96E]/20",
  cream: "text-[#EDE5D6]",
  muted: "text-[#EDE5D6]/45",
};
